<template>
  <div class="modal fade" id="Verify" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- <a href="#" class="modal-close" data-dismiss="modal" aria-label="Close"><em class="ti ti-close"></em></a>         -->
        <a href="#!" class="modal-close" @click="hideModal" aria-label="Close"><em class="ti ti-close"></em></a>        
        <div class="ath-container m-0">
          <div class="ath-body bg-theme tc-light">
            <h5 class="ath-heading title">Verification <small class="tc-default">Result</small></h5>
            <div class="" v-if="!uploadRes">
              <div class="stampIM" >   
                <div class="d-flex justify-content-center" v-if="imgLoad">
                <!-- <div class="d-flex justify-content-center"> -->
                  <div class="spinner-grow text-secondary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
                <img :src="imgSrc" id="imageTest" @load="hideImage" alt="stamp-img" :class="{ showImg: imgLoad }">        
                <!-- <img :src="imgSrc" alt="stamp-img">         -->
              </div>
              <strong>Serial: </strong> <br>
              {{serial.serial}} <br>
              <strong>Ref: </strong><br>
              {{serial.ref}} <br><br>
              More information...
              <div class="text-center">
                <img src="/static/images/custom/lock.svg" alt="lock-img">
              </div><br>
              <div class="row">
                <div class="col-6 col-sm-6">
                  <a href="https://play.google.com/store/apps/details?id=com.imaxinacion.nipost.qubit" target="_blank">
                    <img src="/static/images/custom/download-google.png" alt="google-download">
                  </a>
                </div>
                <div class="col-6 col-sm-6">
                  <a href="https://apps.apple.com/ng/app/nipost-qubit/id1477681785#?platform=iphone" target="_blank">
                    <img src="/static/images/custom/download-apple.png" alt="apple-download">
                  </a>
                </div>
              </div><br>
              <a href="https://dance.qubit.ng/auth/login" target="_blank" class="btn btn-link btn-primary btn-block btn-md">Login / Signup</a>
            
              <!-- <p class="text-center bg-white py-2 mb-5" style="color: red !important; word-break: break-all;">{{errMsg}}</p> -->
              <!-- <a href="https://dance.qubit.ng/auth/login" target="_blank" class="btn btn-link btn-primary btn-block btn-md">Login / Signup</a> -->
            </div>
            <div class="text-center" style="overflow-wrap: break-word">
              {{uploadRes}}
            </div>            
            <div class="ath-note text-center" style="display:none;">
              Don’t have an account?
              <a href="#"> <strong>Sign up here</strong></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Loading from 'vue-loading-overlay'
// import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  components: {
    // Loading
  },
  data () {
    return {
      loadImg: ''
    }
  },
  computed: {
    isLoading () {
      return this.$store.state.loading
    },
    serial () {
      return !this.$store.state.serialInfo ? false : this.$store.state.serialInfo.info.stamp
    },
    imgSrc () {
      return !this.$store.state.img ? false : this.$store.state.img
    },
    errMsg () {
      return this.$store.state.errorMsg
    },
    imgLoad () {
      return this.$store.state.imgLoad
    },
    uploadRes () {
      return this.$store.state.uploadRes
    }
  },
  methods: {
    showImg () {
      this.$store.dispatch('toggleImg')
    },
    hideImage() {
      this.$store.dispatch('toggleImgLoader')
    },
    hideModal() {
      this.$store.dispatch('toggleImg')
      // eslint-disable-next-line no-undef
      $('#Verify').modal('hide');
    }
  }
}
</script>

<style scoped>
  .showImg {
    display: none;
  }
</style>
